import styled from 'styled-components';
import { MMediaCarouselCarouselStyle } from './MMediaCarousel.types';

export const Wrapper = styled.div<{ carouselStyle: MMediaCarouselCarouselStyle; hover: boolean }>`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: ${({ carouselStyle }) =>
    carouselStyle === MMediaCarouselCarouselStyle.Standard ? 'var(--t-images-border-radius, 14px)' : '8px'};

  ${({ hover }) =>
    hover &&
    `
    transition: transform 0.3s ease;
    
    &:hover {
      transform: scale(1.02);
    }
  `}
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const SlideContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  picture,
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    aspect-ratio: 1 / 1;
    @media (min-width: 768px) {
      aspect-ratio: 2 / 3;
    }
    @media (min-width: 1200px) {
      aspect-ratio: 3 / 2;
    }
  }
`;

export const ScrimWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
`;

export const LogoWrapper = styled.div`
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  z-index: 2;

  @media (max-width: 768px) {
    top: 1rem;
    left: 1rem;
  }
`;

export const TagWrapper = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 2;

  @media (max-width: 768px) {
    top: 0.75rem;
    left: 0.75rem;
  }
`;

export const ButtonIconWrapper = styled.div`
  position: absolute;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 2;

  @media (max-width: 768px) {
    bottom: 1rem;
    right: 1rem;
  }
`;

export const ArrowWrapper = styled.div<{ position: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  ${({ position }) => (position === 'left' ? 'left: 1rem;' : 'right: 1rem;')}
  transform: translateY(-50%);
  z-index: 3;

  @media (max-width: 768px) {
    ${({ position }) => (position === 'left' ? 'left: 0.5rem;' : 'right: 0.5rem;')}
  }
`;

export const ControlsWrapper = styled.div`
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;

  @media (max-width: 768px) {
    bottom: 1rem;
  }
`;
